module.exports = __webpack_public_path__ + "img/exclamation-icon.4311863f.svg";